import { notification } from "antd";
import { EditingProps, LoadingState, MediaItem } from "../types/types";
import { get, post, put } from "./apiUtils";

export const fetchCodes = async (
  projectId: string,
  setLoading: React.Dispatch<React.SetStateAction<LoadingState>>,
  setTableData: React.Dispatch<React.SetStateAction<MediaItem[]>>
) => {
  setLoading((prev: any) => ({ ...prev, codes: true }));
  try {
    const response = await get<any>(`/codes?project_id=${projectId}`, {});
    console.log("Fetched codes:", response); // Debug output

    if (response?.type === "success") {
      const sortedData = [...response.data].sort(
        (a, b) =>
          new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
      );
      setTableData(sortedData);
    }
  } catch (error) {
    console.error("Error fetching codes", error);
  } finally {
    setLoading((prev: any) => ({ ...prev, codes: false }));
  }
};

export const handleSubmitCode = async ({
  editing,
  form,
  projectId,
  setLoading,
  setShowAddCodeModal,
  fetchCodes,
}: {
  editing: EditingProps;
  form: any;
  projectId: string;
  setLoading: React.Dispatch<React.SetStateAction<LoadingState>>;
  setShowAddCodeModal: (value: boolean) => void;
  fetchCodes: () => void;
}) => {
  setLoading((prev: any) => ({ ...prev, submit: true }));
  const values = form.getFieldsValue();

  const params = {
    name: values.codeName,
    description: values.codeDescription,
    project_id: projectId,
  };

  try {
    const response = editing.isEditing
      ? await put(`/codes/${editing.id}`, params)
      : await post(`/codes/`, params);

    if (response?.type === "success") {
      setShowAddCodeModal(false);
      notification.success({
        message: "Success",
        description: editing.isEditing
          ? "Code updated successfully"
          : "Code added successfully",
      });
      fetchCodes();
    }
  } catch (error) {
    console.error("Error submitting code:", error);
    notification.error({
      message: "Error",
      description: editing.isEditing
        ? "Failed to update code."
        : "Failed to add code.",
    });
  } finally {
    setLoading((prev: any) => ({ ...prev, submit: false }));
  }
};
